/**
 * /reseller-domains — migrated from public/js/rsdomains.js.
 * Doar sticky-menu + bookmark scrollspy (logica partajata cu b-email).
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';

new Resort(() => {
    initStickyBookmarks();
});
